import SplittingRoutingPartnerInfoScreen from './screens/splittingroutingpartnerinfo-screen';
import { RouteDefinition } from '../../core/route';

export const splittingroutingpartnerinfoRoutes: RouteDefinition[] = [
  {
    id: 'SplittingRoutingPartnerInfoList',
    title: 'Customer Carrier Information',
    path: 'splitting-routing-rule',
    element: <SplittingRoutingPartnerInfoScreen />,
    showInNavigation: true,
  },
];

